
<div class="document-creation-container">

  <div class="document-creation-intro">
    <div class="document-creation-intro-icon">
      <i class="pi pi-cloud-upload"></i>
    </div>

    <div class="document-creation-intro-text">
      <h3>Caricamento documento</h3>
      <p>
        Seleziona un file da caricare nell'archivio documentale.
        Puoi verificare e aggiornare le informazioni prima del caricamento.
      </p>
    </div>
  </div>

  <!-- CARICAMENTO FILE -->

  <div class="document-creation-section">
    <div class="document-creation-section-heading">
      <i class="pi pi-file"></i>
      <span>Seleziona un documento</span>
    </div>

    <div class="document-creation-upload">
      <p-fileUpload
        uploadLabel="Carica..."
        cancelLabel="Svuota"
        chooseIcon="pi pi-search"
        chooseLabel="Cerca..."
        [multiple]="false"
        [maxFileSize]="6000000"
        [customUpload]="true"
        (onSelect)="onFileSelected($event)"
        (uploadHandler)="onBasicUploadAuto($event)"
      >
        <ng-template let-file pTemplate="file">
          <div class="document-creation-selected-file">
            <i class="pi pi-check-circle"></i>
            <span>File caricato localmente</span>
          </div>
        </ng-template>
      </p-fileUpload>
    </div>

    <p class="document-creation-upload-hint">
      Dimensione massima consentita: 6 MB.
    </p>
  </div>

  <!-- INFORMAZIONI DOCUMENTO -->

  <div
    class="document-creation-section document-creation-details"
    *ngIf="document !== undefined"
  >
    <div class="document-creation-section-heading">
      <i class="pi pi-info-circle"></i>
      <span>Informazioni documento</span>
    </div>

    <div class="document-creation-field">
      <label for="filename">Nome file</label>

      <input
        id="filename"
        [(ngModel)]="document.name"
        type="text"
        pInputText
        placeholder="Nome del documento"
      />
    </div>

    <div class="document-creation-field">
      <label>Tipo di file</label>

      <div class="document-creation-file-type">
        <i class="pi pi-file"></i>
        <span>
          {{ document.mimeType || 'Non specificato' }}
        </span>
      </div>
    </div>

    <div class="document-creation-statuses">
      <div class="document-creation-status">
        <div class="document-creation-status-label">
          <i class="pi pi-verified"></i>
          <span>Protocollato</span>
        </div>

        <p-toggleButton
          [(ngModel)]="document.hasProtocol"
          onLabel="Sì"
          offLabel="No"
        ></p-toggleButton>
      </div>

      <div class="document-creation-status">
        <div class="document-creation-status-label">
          <i class="pi pi-pencil"></i>
          <span>Firmato</span>
        </div>

        <p-toggleButton
          [(ngModel)]="document.isSigned"
          onLabel="Sì"
          offLabel="No"
        ></p-toggleButton>
      </div>
    </div>
  </div>

</div>
